import Vue from 'vue'
import Vuex from 'vuex'
import system from './stores/system'
import user from './stores/user'
import client from './stores/client'
import jobs from './stores/jobs'
import message from './stores/message'
import competitions from './stores/competitions'
import chatRequests from './stores/chat_requests'
import temporary from './stores/temporary'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    system,
    user,
    client,
    jobs,
    message,
    competitions,
    chatRequests,
    temporary
  },
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  }
})
